<script>
import LadContentLoader from './common'

export default {
  name: 'LadExperienceCardLoader',
  functional: true,
  render(h, { data }) {
    return (
      <LadContentLoader height={395} width={220}>
        <rect x='0' y='0' rx='0' ry='0' width='220' height='270' />
        <rect x='0' y='275' rx='0' ry='0' width='200' height='15' />
        <rect x='0' y='295' rx='0' ry='0' width='160' height='15' />
        <rect x='0' y='315' rx='0' ry='0' width='120' height='40' />
      </LadContentLoader>
    )
  },
}
</script>
